// src/components/Login.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
 // ✅ enable navigation
import {db} from '../db/firebase';

import { doc, getDoc } from 'firebase/firestore';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      setLoading(true);
      const userCredential = await login(email, password);
      const user = userCredential.user;

      // ✅ Fetch user document from Firestore
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      const userData = userDoc.exists() ? userDoc.data() : {};

      alert('Login successful!');

      // ✅ Role-based navigation
      if (userData.Role === 'admin' || userData.Role === 'main-admin') {
        navigate('/admin'); // Redirect to Admin Dashboard
      } else {
        navigate('/'); // Redirect to normal homepage
      }
    } catch (err) {
      setError('Failed to log in. ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-offwhite">
      <div className="w-full max-w-md bg-beige shadow-xl rounded-2xl p-8 border border-tan">
        {/* Heading */}
        <h2 className="text-3xl font-bold text-primary mb-6 text-center">
          Log In
        </h2>

        {/* Error Box */}
        {error && (
          <div className="bg-redburnt text-offwhite p-3 mb-4 rounded-md shadow-md">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-5">
            <label className="block text-darktaupe font-semibold mb-1">Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-3 rounded-lg border border-taupe bg-offwhite text-charcoal focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Password */}
          <div className="mb-6">
            <label className="block text-darktaupe font-semibold mb-1">Password</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full p-3 rounded-lg border border-taupe bg-offwhite text-charcoal focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Submit Button */}
          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-primary text-offwhite py-3 rounded-lg font-semibold shadow-md hover:bg-tan transition duration-300 disabled:opacity-50"
          >
            {loading ? 'Logging In...' : 'Log In'}
          </button>
        </form>

        {/* Extra Note */}
        <p className="text-center text-sm text-darktaupe mt-6">
          Don’t have an account?{" "}
          <span 
            className="text-primary font-semibold cursor-pointer hover:underline"
            onClick={() => navigate('/signup')} // ✅ navigate to signup
          >
            Sign Up
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
